import { useEffect } from 'react';

const MD_MIN = '(min-width: 768px)';

/**
 * 行の「⋯」details: xs のみ同時に1つ・外側タップで閉じる。
 * md+ は syncSampleRowMoreOpenForViewport が全行 open（詳細/編集/削除を常時表示）するため排他しない。
 */
export function useSampleRowMoreExclusive(wrapperId = 'sample-manager-table-wrapper'): void {
  useEffect(() => {
    const root = document.getElementById(wrapperId);
    if (!root) return;

    const isDesktop = () => window.matchMedia(MD_MIN).matches;

    const closeOthers = (except?: HTMLDetailsElement) => {
      root.querySelectorAll('details.sample-row-more[open]').forEach((el) => {
        if (el !== except) el.removeAttribute('open');
      });
    };

    const onToggle = (event: Event) => {
      if (isDesktop()) return;
      const target = event.target;
      if (!(target instanceof HTMLDetailsElement) || !target.classList.contains('sample-row-more')) {
        return;
      }
      if (target.open) closeOthers(target);
    };

    const onPointerDown = (event: PointerEvent) => {
      if (isDesktop()) return;
      const node = event.target;
      if (!(node instanceof Node)) return;
      const open = root.querySelector('details.sample-row-more[open]');
      if (!open || open.contains(node)) return;
      closeOthers();
    };

    root.addEventListener('toggle', onToggle, true);
    document.addEventListener('pointerdown', onPointerDown, true);
    return () => {
      root.removeEventListener('toggle', onToggle, true);
      document.removeEventListener('pointerdown', onPointerDown, true);
    };
  }, [wrapperId]);
}
